import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxUserProject/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}
export function delObj (id) {
  return axios({
    url: `/sxUserProject/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxUserProject/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxUserProject/saves`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxUserProject/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
// 根据projectId获取项目成员所有信息
export function getByProjectId (projectId) {
  return axios({
    url: `/sxUserProject/getByProjectId?projectId=${projectId}`,
    method: 'GET'
  })
}
